<h1 mat-dialog-title>
    Confirm Delete
    <mat-icon (click)="onNoClick()" style="float: right;">close</mat-icon>
</h1>
<div mat-dialog-content>
    <p>Are you sure you want to delete this record?</p>
</div>
<div mat-dialog-actions style="justify-content: right;">
    <button mat-flat-button color="warn" (click)="onNoClick()">No</button>
    <button mat-flat-button class="daxa" [mat-dialog-close]="true">Yes</button>
</div>